"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapValues = void 0;

var mapValues = function mapValues(values) {
  var newMap = new Map();

  for (var _key in values) {
    if (values.hasOwnProperty(_key)) {
      newMap.set(_key, values[_key]);
    }
  }

  return newMap;
};

exports.mapValues = mapValues;